module.exports = __webpack_public_path__ + "assets/img/wexin.8ac22e96.png";